import GeneralRoomEdit from './GeneralRoomEdit.vue';
export default GeneralRoomEdit;
